<template>
  <div id="fileList" class="row">
    <div class="col s12 l11 no-float center-aligned container site-max">
      <div class="list-container col s12">
       <div class="col s12 l8 no-padding">
          <search-field @search="searchFilter" />
       </div>
       <div class="col view-actions">
         <span class="view-label">View</span>
         <button class="btn-floating btn-flat waves-effect transparent" @click="setView('grid')">
           <i class="material-icons grey-text text-darken-3">grid_view</i>
         </button>
         <button class="btn-floating btn-flat waves-effect transparent" @click="setView('list')">
           <i class="material-icons grey-text text-darken-3">view_list</i>
         </button>
       </div>
      </div>
        <div class="flex-row">          
          <div 
            :class="documentView === 'grid' ? 'col s12 m6 l4' :'col s12'" 
            v-for="doc in dataDocsX"
            :key="doc.ID">
            <div class="card hoverable"
                v-if="documentView === 'grid'">
                <div class="center" style="padding: 12px 0px 0px;">
                  <button @click="setActiveDocument(doc)" class="btn btn-small white waves-effect grey-text text-darken-3 view-button rounded">
                    <i class="material-icons-outlined left">search</i> View Document
                  </button>
                  <img :src="docIcon(doc.subtype)" width="100px" v-if="doc.subtype">
                </div>
                <div class="card-content">
                  <div class="title center-align" v-html="doc.title"></div>
                </div>
            </div>
            <div class="list-item" v-else>
              <div class="icon">
                <img :src="docIcon(doc.subtype)" width="24px" v-if="doc.subtype">
              </div>
              <a @click.prevent="setActiveDocument(doc)" href="#!" class="doc-title grey-text text-darken-3" v-html="doc.title"></a>
              <button @click="setActiveDocument(doc)" class="btn-flat btn-floating btn-small right waves-effect grey-text text-darken-1">
                <i class="material-icons-outlined grey-text text-darken-4">open_in_new</i>
              </button>
            </div>
          </div>
        </div>
    </div>
    <file-viewer v-if="activeDocument" @complete="activeDocument = false" :file-in-view="activeDocument" />
  </div>
</template>
<script>
import fileViewer from '@/components/fileViewer.component.vue'
import pdfsvg from '@/assets/pdf-svg.svg'
import wordSvg from '@/assets/word.svg'
import searchField from '@/components/searchField.component.vue'
export default {
  name: 'DocumentsLists',
  props:{
    dataDocs:{
      type: Array,
    }
  },
  components:{
    searchField,
    fileViewer,
  },
  data () {
    return {
      searchFilerValue: '',
      activeDocument: false,
      documentView: 'grid'
    }
  },
  computed:{
    dataDocsX: {
      get () {
        return this.searchFilerValue === ''
        ? this.dataDocs
        : this.dataDocs.filter( x => (x.filename+' '+x.title+' '+x.description).toLowerCase().includes(this.searchFilerValue.toLowerCase()))
      } 
    }
  },
  methods:{
    searchFilter (evt) {
      this.searchFilerValue = evt
    },
    setView(evt) {
      this.documentView = evt
    },
    setActiveDocument (doc) {
    this.activeDocument = 	{
        source_url: doc.url,
        mime_type: doc.mime_type
      }
    },
    docIcon (subtype) {
      return subtype === 'pdf'
        ? pdfsvg
        : subtype === 'msword'
          ? wordSvg
          : ''
    }
  }

}
</script>
<style scoped lang="scss">
  #fileList {
    .container {
      display: flow-root;
      background: #f7f7f7; 
      padding: 22px;
      border-radius: 10px;
    }
  }
  .flex-row {
    display: inline-flex;
    flex-wrap: wrap;
    width: 100%;
    .col {
      margin: 0px !important;
      float: none;
      .card {
        height: calc(100% - 1.5rem);
        img {
          margin-top:12px;
        }
      }
    }
  }
.view-button {
    position: absolute;
    left: 50%; 
    top:50%;
    width: 100%;
    max-width: 180px;
    transform:translate(-50%, -50%);
    opacity: 0;
  }
  .card {
    &:hover {
        .view-button {
          opacity: 1;
        }
    }
  }
  .view-actions {
    .view-label {
      margin: 0 6px;
      button {
        margin-right: 5px;
      }
    }
  }
.list-item {
    display: inline-flex;
    padding: 16px 0px 8px;
    margin-bottom: 4px;
    border-top: 1px solid #d7d7d7;
    width: 100%;
    position: relative;
   .icon {
      margin-right: 12px;
    }
    button {
      position: absolute;
      right: 20px;
      top: 12px;
    }
}

</style>